import { SecondaryButtonLink } from '@chegg-ui/button-link'
import { breakpoints, colors, font, spacing } from '@chegg-ui/theme'
import { Typography } from '@chegg-ui/typography'
import styled from 'styled-components'

export const CardContainer = styled.div<{ isActive: boolean }>`
  cursor: pointer;
  padding: 0 ${spacing.px24};
  padding-top: ${spacing.px32};

  border-radius: ${spacing.px24};
  background-color: ${colors.violet050};

  &:last-of-type {
    padding-bottom: ${spacing.px32};
  }

  @media only screen and (min-width: ${breakpoints.md.min}) {
    padding: ${spacing.px24};
    &:last-of-type {
      padding-bottom: ${spacing.px24};
    }
  }

  @media only screen and (min-width: ${breakpoints.lg.min}) {
    ${({ isActive }) =>
      isActive &&
      `
    background-color: ${colors.white};
  `}
  }
`

export const CardHeading = styled(Typography).attrs({
  variant: 'subtitle',
  variantType: 'bold',
})`
  font-size: ${font.size.px22};
  margin-bottom: ${spacing.px8};
`

export const CardContent = styled(Typography).attrs({
  variant: 'body1',
})`
  font-size: ${font.size.px16};
  margin-bottom: ${spacing.px24};
`

export const ActionButton = styled(SecondaryButtonLink).attrs({
  variant: 'outlined',
  size: 'small',
})<{ isCardActive: boolean }>`
  font-weight: ${font.weight.bold};
  && {
    background-color: ${colors.grey900};
    color: ${colors.white};

    @media only screen and (min-width: ${breakpoints.lg.min}) {
      background: none;
      color: ${colors.grey900};
      ${({ isCardActive }) =>
        isCardActive &&
        `
      background-color: ${colors.grey900};

      color: ${colors.white};
    `}
    }
  }
`
